export const calculateStatistics = (features, responses, organization, comments = {}) => {
    // Convert responses to array if it's an object
    const responsesArray = Array.isArray(responses) 
        ? responses 
        : Object.values(responses).filter(Boolean);

    const totalUsers = new Set(responsesArray.map(response => response.user_id)).size;
    const totalFeatures = features.length;
    const userResponses = responsesArray.filter(response =>
        response.organization_id === organization.id
    );

    const requiredFeatures = new Set(
        userResponses
            .filter(response => response.response_value === 'required')
            .map(response => response.feature_reference)
    ).size;

    const niceToHaveFeatures = new Set(
        userResponses
            .filter(response => response.response_value === 'nice_to_have')
            .map(response => response.feature_reference)
    ).size;

    const notNeededFeatures = new Set(
        userResponses
            .filter(response => response.response_value === 'not_needed')
            .map(response => response.feature_reference)
    ).size;

    const dontKnowFeatures = new Set(
        userResponses
            .filter(response => response.response_value === 'dont_know')
            .map(response => response.feature_reference)
    ).size;

    const undecidedFeatures = totalFeatures - (
        requiredFeatures + niceToHaveFeatures + notNeededFeatures + dontKnowFeatures
    );

    return {
        totalUsers: totalUsers || 0,
        totalFeatures: totalFeatures || 0,
        requiredFeatures: requiredFeatures || 0,
        niceToHaveFeatures: niceToHaveFeatures || 0,
        notNeededFeatures: notNeededFeatures || 0,
        dontKnowFeatures: dontKnowFeatures || 0,
        undecidedFeatures: undecidedFeatures || 0,
        requiredPercentage: totalFeatures ? Math.round((requiredFeatures / totalFeatures) * 100) : 0,
        niceToHavePercentage: totalFeatures ? Math.round((niceToHaveFeatures / totalFeatures) * 100) : 0,
        notNeededPercentage: totalFeatures ? Math.round((notNeededFeatures / totalFeatures) * 100) : 0,
        dontKnowPercentage: totalFeatures ? Math.round((dontKnowFeatures / totalFeatures) * 100) : 0,
        undecidedPercentage: totalFeatures ? Math.round((undecidedFeatures / totalFeatures) * 100) : 0,
        totalComments: Object.values(comments).flat().length || 0
    };
};

export const calculateTeamStats = (teamResponses) => {
    const uniqueUsers = new Set(teamResponses.map(r => r.user_id));
    const responseTypes = teamResponses.reduce((acc, response) => {
        acc[response.response_value] = (acc[response.response_value] || 0) + 1;
        return acc;
    }, {});

    const percentages = Object.entries(responseTypes).reduce((acc, [type, count]) => {
        acc[type] = ((count / teamResponses.length) * 100).toFixed(1);
        return acc;
    }, {});

    return {
        totalResponses: teamResponses.length,
        uniqueUsers: uniqueUsers.size,
        responseTypes,
        percentages,
        averageResponsesPerUser: (teamResponses.length / uniqueUsers.size).toFixed(1)
    };
};

export const calculateFeatureStats = (statistics) => {
    const total = statistics.totalFeatures || 0;
    const percentages = {
        required: ((statistics.requiredFeatures / total) * 100).toFixed(1),
        niceToHave: ((statistics.niceToHaveFeatures / total) * 100).toFixed(1),
        notNeeded: ((statistics.notNeededFeatures / total) * 100).toFixed(1),
        needsInfo: ((statistics.dontKnowFeatures / total) * 100).toFixed(1),
        undecided: ((statistics.undecidedFeatures / total) * 100).toFixed(1)
    };

    return {
        total,
        required: statistics.requiredFeatures || 0,
        niceToHave: statistics.niceToHaveFeatures || 0,
        notNeeded: statistics.notNeededFeatures || 0,
        needsInfo: statistics.dontKnowFeatures || 0,
        undecided: statistics.undecidedFeatures || 0,
        percentages
    };
}; 